import React, { useState } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import "../index.css";

const BASE_URL = process.env.REACT_APP_DATA_FEEDER;
  const token = window.sessionStorage.getItem("jwtToken");

const technicalDataList = [
  {
    name: "Source Symbol Custom Indicators",
    urlNoStock: "/sourceSymbolCustomIndicators",
    urlWithStock: "/calculateSymbolCustomIndicators",
  },
  {
    name: "Calculate Fall From H12 Month",
    urlNoStock: "/calculateFallFromH12Month",
    urlWithStock: "/calculateFallFromH12MonthForStock",
  },
  {
    name: "Calculate Stock ROC Strength",
    urlNoStock: "/calculateStockROCStrength",
    urlWithStock: "/calculateStockROCStrengthByStockName",
  },
  {
    name: "Fetch Symbol Marketcap",
    urlNoStock: "/fetchSymbolMarketcap",
    urlWithStock: "/fetchSymbolMarcapData",
  },
  {
    name: "Transform Into Monthly Table",
    urlNoStock: "",
    urlWithStock: "",
  },
];

const SourceTechnicalData = () => {
  const [monthYearInputs, setMonthYearInputs] = useState({});
  const [stockInputs, setStockInputs] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleMonthYearChange = (index, value) => {
    setMonthYearInputs((prev) => ({ ...prev, [index]: value }));
  };

  const handleStockNameChange = (index, value) => {
    setStockInputs((prev) => ({ ...prev, [index]: value }));
  };

  const handleSourceClick = async (item, index) => {
    const monthYear = (monthYearInputs[index] || "").trim();
    const stockName = (stockInputs[index] || "").trim();

    let url = "";

    if (stockName) {
      // case: user entered stock name
      url = `${BASE_URL}${item.urlWithStock}/${stockName}`;
    } else {
      // case: user did not enter stock name
      if (!monthYear) {
        alert("Please provide Month-Year if Stock Name is not entered.");
        return;
      }
      url = `${BASE_URL}${item.urlNoStock}/${monthYear}`;
    }

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("API call failed");

      const data = await response.text();
      setModalMessage("Success: " + data);
      setShowModal(true);
    } catch (error) {
      console.error("Error:", error);
      setModalMessage(`Error: ${url} failed.`);
      setShowModal(true);
    }
  };

  return (
    <>
      <Navbar />
      <div className="main-content" style={{ paddingTop: "50px" }}>
        <div className="container-fluid" style={{ paddingTop: "20px" }}>
          <h4 className="fw-bold text-center">Source Technical Data</h4>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Technical Data Name</th>
                  <th>Month-Year</th>
                  <th>Stock Name</th>
                  <th style={{ paddingLeft: "30px" }}>Source Data</th>
                </tr>
              </thead>
              <tbody>
                {technicalDataList.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td style={{ maxWidth: "250px" }}>{item.name}</td>
                    <td>
                      <input
                        style={{ width: "100%", maxWidth: "150px" }}
                        className="form-control"
                        value={monthYearInputs[index] || ""}
                        onChange={(e) =>
                          handleMonthYearChange(index, e.target.value)
                        }
                        placeholder="MMMYYYY"
                      />
                    </td>
                    <td>
                      <input
                        style={{ width: "100%", maxWidth: "200px" }}
                        className="form-control"
                        value={stockInputs[index] || ""}
                        onChange={(e) =>
                          handleStockNameChange(index, e.target.value)
                        }
                        placeholder="Stock Name"
                      />
                    </td>
                    <td style={{ paddingLeft: "30px", maxWidth: "200px" }}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSourceClick(item, index);
                        }}
                      >
                        Source Data
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">API Response</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>{modalMessage}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default SourceTechnicalData;
